import { SidebarNav } from "./SidebarNav";

export function Sidebar() {
  return (
    <aside className="hidden lg:flex w-60 shrink-0 flex-col border-r border-panel-border bg-panel/60 backdrop-blur">
      <SidebarNav />
    </aside>
  );
}
